import { useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { Environment } from '@playq/octopus-common';
import { ClusterizationRun, ClusterizationRunId } from '@playq/services-beetle';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const retrieveRunKeys = ['retrieve', 'run'];
export const useRetrieveRun = (
  id: ClusterizationRunId,
  env: Environment = Environment.Live,
  options?: IUseQueryOptionsExtended<ClusterizationRun | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => retrieveRunKeys.concat(id.id, env), [env, id]);

  const { mutate: _mutate, ...res } = useEitherQuery(
    keys,
    () => services2.audienceRequestsClusterizationService.retrieveRun(id, env),
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );
  const clusterizationRun = res.data;
  return { ...res, clusterizationRun };
};
